import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateDeliverable } from "./api";
import {
  buildM2MChange,
  invalidateAllDeliverablesQueries,
  uploadFiles,
} from "../query";
import {
  FILES_FIELD,
  FILES_JUNCTION_KEY,
  SKILLS_FIELD,
  SKILLS_JUNCTION_KEY,
} from "../../constants";

/**
 * `item` holds dirty values only. `skillJunctions` / `fileJunctions` map
 * related ids to the junction row ids loaded with the deliverable.
 */
export function useUpdateDeliverable() {
  return useMutation({
    mutationFn: async ({ item, deliverableId, skillJunctions, fileJunctions }) => {
      const payload = { ...item };

      if (FILES_FIELD in payload) {
        const fileIds = await uploadFiles(payload[FILES_FIELD]);
        payload[FILES_FIELD] = buildM2MChange(fileIds, fileJunctions, FILES_JUNCTION_KEY);
        if (!payload[FILES_FIELD]) delete payload[FILES_FIELD];
      }
      if (SKILLS_FIELD in payload) {
        payload[SKILLS_FIELD] = buildM2MChange(
          payload[SKILLS_FIELD] ?? [],
          skillJunctions,
          SKILLS_JUNCTION_KEY
        );
        if (!payload[SKILLS_FIELD]) delete payload[SKILLS_FIELD];
      }

      if (!Object.keys(payload).length) return null;
      return updateDeliverable({ item: payload, deliverableId });
    },
    onSuccess: () => {
      toast.success("Deliverable Updated Successfully");
      invalidateAllDeliverablesQueries();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
